import(/* webpackMode: "eager" */ "/workspace/dotheforgejo/oxpa-pro/src/app/(portal)/cabinet/layout.tsx");
